import {apiClient} from './axios.ts';
import {PaginationData} from '../models/paginationData.ts';
import {TtsDashboard, TtsAudioItem} from '../types/tts.ts';

export const ttsApi = {
    getDashboard: () =>
        apiClient.get<TtsDashboard>('/admin/tts/dashboard'),

    getAudioList: (page: number, size: number, lang?: string, search?: string) =>
        apiClient.get<PaginationData<TtsAudioItem>>('/admin/tts/audio', {
            page,
            size,
            ...(lang ? {lang} : {}),
            ...(search ? {search} : {}),
        }),

    regenerateAudio: (id: number) =>
        apiClient.postNoData(`/admin/tts/audio/${id}/regenerate`),
};
